import React, { useState } from "react";
import {
  Layout,
  Button,
  Menu,
  Card,
  Typography,
  BackTop  
} from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,HomeOutlined 
} from "@ant-design/icons";
import { createGlobalStyle } from "styled-components";

import Dashboard7_1 from "./Dashboard7_1";
import Dashboard7_2 from "./Dashboard7_2";
import Dashboard7_3 from "./Dashboard7_3";
import Dashboard7_4 from "./Dashboard7_4";
import Dashboard7_5 from "./Dashboard7_5";

const { Content, Sider, Header } = Layout;
const { Title } = Typography;

const GlobalStyle = createGlobalStyle`
  body {
    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);
  }

  .ant-layout {
    background: transparent;
  }

  .ant-menu-item-selected {
    background: #e6f4ff !important;
    border-radius: 8px;
  }

  .ant-menu-item:hover {
    background: #f0f5ff !important;
    border-radius: 8px;
  }
`;

const Dashboard_index = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [page, setPage] = useState("1");

  const items = [
    { key: "1", icon: <PieChartOutlined />, label: "Dashboard 7.1" },
    { key: "2", icon: <PieChartOutlined />, label: "Dashboard 7.2" },
    { key: "3", icon: <PieChartOutlined />, label: "Dashboard 7.3" },
    { key: "4", icon: <PieChartOutlined />, label: "Dashboard 7.4" },
    { key: "5", icon: <PieChartOutlined />, label: "Dashboard 7.5" },
  ];

  return (
    <>
      <GlobalStyle />

      <Layout style={{ minHeight: "100vh" }}>
        {/* Sidebar */}
        <Sider
          collapsible
          collapsed={collapsed}
          trigger={null}
          width={240}
          theme="light"
          style={{
            padding: 16,
            background: "#fff",
            boxShadow: "2px 0 12px rgba(0,0,0,0.06)"
          }}
        >
          <div
            style={{
              padding: "12px 16px",
              marginBottom: 24,
              textAlign: collapsed ? "center" : "left",
              fontWeight: 600,
              fontSize: 18,
              color: "#1677ff"
            }}
          >
            {collapsed ? "D4" : "📊 Dashboard 4"}
          </div>

          <Menu
            mode="inline"
            selectedKeys={[page]}
            items={items}
            onClick={(e) => setPage(e.key)}
            style={{ border: "none" }}
          />
        </Sider>

        {/* Main Layout */}
        <Layout style={{ padding: 24 }}>

          {/* Header */}
          <Header
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: "0 24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
              marginBottom: 24
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
              />
              <Title level={4} style={{ margin: "0 0 0 16px" }}>
                Dashboard Overview
              </Title>
            </div>

            <div style={{ color: "#888" }}>
              <a href="/" style={{ color: "#888", textDecoration: "none" }}>
                <HomeOutlined style={{ marginRight: 6 }} />
                  Home
              </a>
            </div>
          </Header>

          {/* Content */}
          <Content>
            <Card
              bordered={false}
              style={{
                borderRadius: 16,
                boxShadow: "0 6px 24px rgba(0,0,0,0.05)",
                minHeight: 500
              }}
            >
              {page === "1" && <Dashboard7_1 />}
              {page === "2" && <Dashboard7_2 />}
              {page === "3" && <Dashboard7_3 />}
              {page === "4" && <Dashboard7_4 />}
              {page === "5" && <Dashboard7_5 />}
            </Card>
          </Content>

        </Layout>
      </Layout>
      <BackTop>
        <div
          style={{
            height: 40,
            width: 40,
            lineHeight: "45px",
            borderRadius: 10,
            backgroundColor: "#7aabf0",
            color: "#fff",
            textAlign: "center",
            fontSize: 30
          }}
        >
          ^
        </div>
      </BackTop>
    </>
  );
};

export default Dashboard_index;
